import { Component, OnDestroy } from '@angular/core';
import {
  ResultAttribute,
  UserPreferencesState,
  UserPreferencesStateKey
} from '@approot/models';
import {
  LegService,
  ProductsConfigService,
  UserStorageService
} from '@approot/services';
import { Subscription } from 'rxjs';

type Attr = { [key: string]: boolean };

@Component({
  selector: 'pricing-results-attributes',
  templateUrl: './pricing-results-attributes.component.html',
  styleUrls: ['./pricing-results-attributes.component.scss']
})
export class PricingResultsAttributesComponent implements OnDestroy {
  public resultSpecifications: ResultAttribute[];
  private sub: Subscription;

  constructor(
    private legService: LegService,
    private productsConfigService: ProductsConfigService,
    private userStorageService: UserStorageService
  ) {
    this.sub = this.userStorageService
      .storeChangesObservable<UserPreferencesState>(UserPreferencesStateKey)
      .subscribe(prefs => {
        const displayAttributes: Attr = prefs.PricingDisplayPrefs;
        this.resultSpecifications =
          this.productsConfigService.pricingResultsInfo.resultSpecifications.filter(
            r => (displayAttributes[r.shortName] ?? true) || !!r.header
          );
      });
  }

  public ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  public tooltip(shortName: string): string | null {
    if (shortName === 'brokerDelta') {
      return `Spot and Forward Deltas are Smile Deltas, including premium when
        applicable (c.f., currency pair definitions) BS Delta ('Broker
        Delta') is a spot or forward delta (depending on the option's
        currency pair and tenor) including premium when applicable (c.f.,
        currency pair definitions).`;
    } else {
      return null;
    }
  }

  public get pricingResultsExpanded(): boolean {
    return this.legService.pricingResultsExpanded;
  }

  public set pricingResultsExpanded(val: boolean) {
    this.legService.pricingResultsExpanded = val;
  }
}
